import { render } from "./ParentMenuItem.vue?vue&type=template&id=e0d8b7e4"
import script from "./ParentMenuItem.vue?vue&type=script&lang=js"
export * from "./ParentMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__